{
  "de": {
    "document": {
      "actions": {
        "clear_selection": "Auswahl aufheben",
        "delete": "Löschen",
        "deleteMultipleDocuments": "Löschen",
        "delete_cancel": "Abbrechen",
        "delete_documents": "Dokument löschen | Dokumente löschen",
        "delete_documents_upload": "{count} Dokument entfernen | {count} Dokumente entfernen",
        "download": "Herunterladen",
        "edit": "Bearbeiten",
        "edit_category": "Kategorie bearbeiten",
        "groupByCategory": "Gruppierung nach Kategorie umschalten",
        "hideDetails": "Details ausblenden",
        "hide_for_project_partners": "Für Projektpartner ausblenden",
        "new": "Dokumente",
        "new_customer": "Dokumente hinzufügen",
        "reset_filters": "Filter zurücksetzen",
        "select_all": "Alle {total} Dokumente auswählen",
        "share": "Teilen",
        "shareCustomer": "Mit Kunden teilen",
        "shareCustomerPartners": "Mit Kunden und Projektpartnern teilen",
        "share_documents": "Dokument teilen | Dokumente teilen",
        "share_with": "Teilen mit …",
        "share_with_project_partners": "Mit Projektpartnern teilen",
        "showDetails": "Details anzeigen",
        "submit": "Absenden",
        "tickBoxesDeletion": "Aktivieren Sie die Kontrollkästchen der Dateien, die Sie löschen möchten.",
        "unshare": "Freigabe aufheben",
        "unshare_documents": "Freigabe für Dokument aufheben | Freigabe für Dokumente aufheben"
      },
      "attachable_types": {
        "building": "Gebäude",
        "decisions": "Entscheidungen",
        "installment": "Rate",
        "issue": "Punkt",
        "lot": "Grundstück",
        "phase": "Phase",
        "project": "Projekt",
        "tickets": "Konversationen",
        "unit": "Einheit"
      },
      "attributes": {
        "category": "Kategorie",
        "file_ext": "Dateityp",
        "file_size": "Dateigröße",
        "name": "Name",
        "size": "Größe",
        "type": "Typ",
        "uploaded_at": "Hochgeladen am",
        "uploaded_by": "Hochgeladen von"
      },
      "category": {
        "admin": "Verwaltung",
        "aftercare": "Nachbetreuung",
        "as_built": "Gebäudeakte",
        "brochure": "Broschüre",
        "conversation": "Konversation",
        "decision": "Entscheidung",
        "image": "Bild",
        "invoice": "Rechnung",
        "legal": "Rechtliches",
        "manual": "Anleitung",
        "other": "Sonstiges",
        "plan": "Plan",
        "quote": "Kostenvoranschlag",
        "ticket": "Konversation"
      },
      "labels": {
        "actions": "Aktionen",
        "allDocuments": "Alle Dokumente",
        "allUnits": "Alle Einheiten",
        "backToCategories": "Kategorien",
        "building": "Gebäude",
        "categories": "Kategorien",
        "category": "Kategorie",
        "changeCategory": "Kategorie ändern zu:",
        "changeFilterOrStartUploading": "Filter ändern oder ein neues Dokument hochladen",
        "created": "Erstellt",
        "customer": "Kunde",
        "decision": "Entscheidung",
        "decisionsAndProposals": "Entscheidungen und Angebote",
        "delete_documents": "Sind Sie sicher, dass Sie dieses Dokument entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden. | Sind Sie sicher, dass Sie diese Dokumente entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        "disclaimerDocumentsCustomer": "Suchen oder laden Sie Dokumente zur Entscheidung {decision_name} hoch",
        "documents": "Dokumente",
        "documents_all": "Alle Dokumente",
        "documents_all_projects": "Dokumente aller Projekte",
        "documents_plan": "Plandokumente",
        "documents_plan_explainer": "Dokumente, die dem Dokumentenordner von {unit_name} mit der Kategorie „Plan“ hinzugefügt werden, werden automatisch zu dieser Entscheidung hinzugefügt und sind für alle Partner zugänglich. ",
        "editDocument": "Dokument bearbeiten",
        "editDocumentName": "Dokumentnamen bearbeiten",
        "editDocumentNameSubtitle": "Geben Sie einen neuen Namen für das Dokument ein.",
        "fileTooLargeForPreview": "Datei zu groß für die Vorschau. Laden Sie sie stattdessen herunter.",
        "files": "Dateien {level_name}",
        "files_count": "Keine Dateien | 1 Datei | {count} Dateien",
        "filter": "Filter",
        "folders": "Ordner",
        "goToUnitDocumentsFolder": "Zum Dokumentenordner von {unit_name} gehen",
        "goToUnitsFolder": "Diese Seite enthält nur Entscheidungsdokumente. Gehen Sie zum Einheitenordner, um die anderen Dokumente zu sehen.",
        "include_original_documents": "Die zu unterschreibenden Dokumente anzeigen",
        "includesProposalAndDocuments": "Enthält Angebotsdokumente und Entscheidungsdokumente",
        "info": "Dokumente zu Ihrem Zuhause werden hier bald verfügbar sein.",
        "lockedDocumentApprovedProposal": "Dieses Dokument gehört zu einem genehmigten Angebot und kann nicht gelöscht werden",
        "lockedDocumentDelete": "Dieses Dokument kann nicht gelöscht werden",
        "lockedDocumentOtherLevel": "Dieses Dokument gehört zu {level} und kann nur aus den Dokumenten von {level} gelöscht werden",
        "lockedDocumentShareLevel": "Dieses Dokument gehört zu {level} und kann nicht mit Projektpartnern geteilt werden",
        "locked_parent_level": "Dieses Dokument wird auf einer höheren Ebene verwaltet und kann nur dort bearbeitet oder gelöscht werden",
        "locked_template": "Dieses Dokument wurde aus einer Vorlage erstellt und kann nicht bearbeitet oder gelöscht werden",
        "lot": "Grundstück",
        "more_info": "Weitere Informationen",
        "name_asc": "Name A - Z",
        "name_desc": "Name Z - A",
        "name_lower_asc": "Name A - Z",
        "name_lower_desc": "Name Z - A",
        "new": "Neu",
        "next": "Weiter",
        "noCustomer": "Noch kein Kunde zugewiesen",
        "noPreviewPossible": "Keine Vorschau möglich. Laden Sie es zuerst herunter.",
        "noResults": "Keine Ergebnisse",
        "no_plan_documents": "Keine Plandokumente im Einheitenordner hinzugefügt",
        "onlyUnitDocumentsSharedWithProjectPartners": "Nur Dokumente der Einheit können mit Projektpartnern geteilt werden",
        "original_documents": "Originaldokumente",
        "original_documents_info": "Die ursprünglichen, nicht unterschriebenen Versionen der Dokumente anzeigen, die unterschrieben sind oder unterschrieben werden müssen.",
        "owner": "Eigentümer",
        "page": "Seite",
        "phase": "Phase",
        "previous": "Zurück",
        "project": "Projekt",
        "project_partners": "Projektpartner",
        "proposal": "Angebot",
        "searchName": "Nach Namen suchen",
        "search_document": "Dokument suchen",
        "selected": "{count} Dokument ausgewählt | {count} Dokumente ausgewählt",
        "selected_count": "{selected} Dokument ausgewählt | {selected} Dokumente ausgewählt",
        "shareWith": "Teilen mit",
        "sharedWithClient": "Geteilt mit {client_name}",
        "sharedWithProjectPartners": "Geteilt mit Projektpartnern",
        "shared_with": "Geteilt mit",
        "shared_with_partners": "Geteilt mit Partnern",
        "sharingSettingsDecision": "Innerhalb dieser Entscheidung",
        "sharingSettingsProject": "In diesem Projekt",
        "showDocumentsFor": "Dokumente anzeigen für",
        "showLevel": "Dies ist ein Dokument von {level}",
        "signature": "Unterschrift",
        "signed": "Unterschrieben",
        "signedBy": "Unterschrieben von",
        "source": "Quelle",
        "subtitleSharingDocuments": "Das ausgewählte Dokument wird für Projektpartner verfügbar sein | Die ausgewählten Dokumente werden für Projektpartner verfügbar sein",
        "subtitleUnsharingDocuments": "Das ausgewählte Dokument wird für Projektpartner nicht mehr verfügbar sein | Die ausgewählten Dokumente werden für Projektpartner nicht mehr verfügbar sein",
        "ticket": "Konversation",
        "total_selected": "Alle {total} Dokumente ausgewählt",
        "unit": "Einheit",
        "unitFolder": "Zu den Dokumenten der Einheit gehen",
        "updated_at_asc": "Älteste zuerst",
        "updated_at_desc": "Neueste zuerst",
        "upload_failed": "1 oder mehr Dateien konnten nicht hochgeladen werden. Entfernen Sie sie oder versuchen Sie es erneut.",
        "uploadedBy": "Hochgeladen von",
        "visibleFor": "Geteilt mit",
        "warningNotShared": "Hoppla! Es wurde niemand ausgewählt. Sind Sie sicher? Klicken Sie erneut, um zu bestätigen."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Sie erhalten eine E-Mail-Benachrichtigung, sobald ein neues Dokument verfügbar ist. Hier können Sie es ansehen und herunterladen.",
            "title": "Hier finden Sie alle Ihre Dokumente"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Hochgeladene Dokumente benachrichtigen automatisch alle betroffenen Kunden per E-Mail.",
            "title": "Keine Dokumente für {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navigieren Sie durch die Projektstruktur, um die Dokumente einer Einheit zu sehen",
            "title": "Gehen Sie zu einer Einheit, um Dokumente zu sehen"
          },
          "new": {
            "subtitle": "Hochgeladene Dokumente benachrichtigen automatisch alle betroffenen Kunden per E-Mail.",
            "title": "Keine Dokumente für diese Entscheidung"
          },
          "none": {
            "subtitle": "Hier finden Sie Dokumente für {unit}",
            "title": "Noch keine Dokumente"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Dokument erfolgreich gelöscht | Dokumente erfolgreich gelöscht",
        "bulk_upload": "Dokument erfolgreich hochgeladen | Dokumente erfolgreich hochgeladen",
        "update": "{count} Dokument erfolgreich aktualisiert | {count} Dokumente erfolgreich aktualisiert",
        "upload_success": "{count} Dokument erfolgreich hochgeladen | {count} Dokumente erfolgreich hochgeladen"
      },
      "upload": {
        "activeUpload": "{count} Datei wird hochgeladen | {count} Dateien werden hochgeladen",
        "clear": "Leeren",
        "complete": "Upload abgeschlossen",
        "navigationWarning": {
          "continue": "Trotzdem verlassen",
          "header": "Upload läuft",
          "message": "Sie haben derzeit Dateien, die hochgeladen werden. Wenn Sie diese Seite verlassen, wird der Upload abgebrochen und es wird kein Dokument erstellt."
        },
        "uploadFailed": "Upload fehlgeschlagen"
      },
      "validation": {
        "need_category": "Kategorie erforderlich",
        "need_category_all": "Alle Dokumente benötigen eine Kategorie",
        "selectDocument": "Wählen Sie mindestens 1 Dokument aus"
      }
    }
  }
}
